import { render } from "./CompanyViseJob.vue?vue&type=template&id=068e1523&ts=true"
import script from "./CompanyViseJob.vue?vue&type=script&lang=ts"
export * from "./CompanyViseJob.vue?vue&type=script&lang=ts"

import "./CompanyViseJob.vue?vue&type=style&index=0&id=068e1523&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__